import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Megaphone } from "lucide-react";
import api, { img } from "@/lib/api";

const AdCard = ({ ad }) => {
  const inner = (
    <div className="w-64 shrink-0 border border-white/10 bg-[#151A21] group hover:border-[#6EA8FF]/50 transition-colors" data-testid={`ad-card-${ad.id}`}>
      {ad.media_type === "video" ? (
        <video src={ad.media_url} className="w-full h-32 object-cover" muted autoPlay loop playsInline />
      ) : (
        <img src={img(ad.media_url, 480)} alt={ad.headline} className="w-full h-32 object-cover" loading="lazy" />
      )}
      <div className="p-3">
        <p className="text-sm font-medium truncate text-neutral-100">{ad.headline}</p>
        <p className="text-xs text-neutral-500">{ad.business_name}</p>
      </div>
    </div>
  );
  return ad.link_url ? <a href={ad.link_url} target="_blank" rel="noreferrer sponsored">{inner}</a> : inner;
};

export const AdsMarquee = () => {
  const [ads, setAds] = useState([]);
  useEffect(() => { api.get("/ads/active").then((r) => setAds(r.data)).catch(() => {}); }, []);
  if (ads.length === 0) return null;
  const loop = [...ads, ...ads];

  return (
    <section className="mt-16 border-y border-white/10 bg-white/[0.02] py-6 overflow-hidden" data-testid="ads-marquee">
      <style>{`@keyframes ads-scroll { from { transform: translateX(0); } to { transform: translateX(-50%); } }`}</style>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between mb-4">
        <span className="label-caps flex items-center gap-2 text-neutral-500"><Megaphone className="w-4 h-4" />Sponsored · Featured businesses</span>
        <Link to="/advertise" className="text-xs text-[#6EA8FF] hover:underline" data-testid="ads-advertise-link">Advertise with us →</Link>
      </div>
      <div className="relative">
        <div className="flex gap-4 w-max" style={{ animation: `ads-scroll ${Math.max(ads.length * 8, 24)}s linear infinite` }}
          onMouseEnter={(e) => (e.currentTarget.style.animationPlayState = "paused")}
          onMouseLeave={(e) => (e.currentTarget.style.animationPlayState = "running")}>
          {loop.map((ad, i) => <AdCard key={`${ad.id}-${i}`} ad={ad} />)}
        </div>
      </div>
    </section>
  );
};
